const autoNgTemplateLoaderTemplate1 = require('./applicationsDatatable.html');

import './applicationsDatatable.css';

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    settingsKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
    onPublishingModeClick: '<',
    isPrimary: '<',
  },
});
